import * as z from 'zod';

export const DEFAULT_PROMPT_VALUE_CHARACTER_LIMIT = 2000;

export const createPromptValueSchema = (
  characterLimit: number | null = DEFAULT_PROMPT_VALUE_CHARACTER_LIMIT,
) => {
  const textSchema = z.string()
    .min(1, { message: 'This field is required' })
    .min(10, { message: 'Value must be at least 10 characters long' });

  const lengthValidatedTextSchema = characterLimit === null
    ? textSchema
    : textSchema.max(characterLimit, {
      message: `Value cannot exceed ${characterLimit} characters`,
    });

  return z.object({
    text: lengthValidatedTextSchema.refine((text) => {
      const trimmedText = text.trim();
      const uniqueChars = new Set(trimmedText.toLowerCase()).size;
      return trimmedText.length >= 10 && uniqueChars >= 3;
    }, { message: 'Value must contain meaningful content' }),
  });
};

export type PromptValueFormData = z.infer<ReturnType<typeof createPromptValueSchema>>;
